import styled from "styled-components";
import {
  BASIC_DARK_GRAY,
  BASIC_GRAY_BACKGROUND,
} from "../../../constants/colors";
import { CouponMenu } from "../../../ducks/coupon";
import { MenuCountSelect } from "../menu/MenuCountSelect";

type Props = {
  menu: CouponMenu;
  quantity: number;
  disabled: boolean;
  onChange: (quantity: number) => void;
};

export const AppCouponMenuItem: React.FC<Props> = ({
  menu,
  quantity,
  disabled,
  onChange,
}) => {
  return (
    <MenuItemContainer>
      <MenuItemContent>
        <MenuImage src={menu.imageUrl} alt={menu.name} />

        <MenuDetail>
          <MenuName>{menu.name}</MenuName>
          <MenuPrice>
            ¥{menu.price.toLocaleString()}
            <MenuPriceWithTax>
              （税込¥{menu.priceWithTax.toLocaleString()}）
            </MenuPriceWithTax>
          </MenuPrice>
        </MenuDetail>

        <MenuQuantityButton>
          <MenuCountSelect
            initialCount={quantity}
            disabled={disabled}
            onChange={onChange}
            size="sm"
          />
        </MenuQuantityButton>
      </MenuItemContent>
    </MenuItemContainer>
  );
};

const MenuItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${BASIC_GRAY_BACKGROUND};
  padding: 10px;
`;

const MenuItemContent = styled.div`
  position: relative;
  display: flex;
  align-items: start;
  margin-bottom: 15px;
`;

const MenuImage = styled.img`
  width: 50px;
  height: 50px;
  margin-right: 16px;
  object-fit: cover;
`;

const MenuDetail = styled.div`
  flex: 1;
  text-align: left;
`;

const MenuName = styled.div`
  font-weight: bold;
`;

const MenuPrice = styled.div`
  font-size: 12px;
  color: ${BASIC_DARK_GRAY};
`;

const MenuPriceWithTax = styled.span`
  font-size: 10px;
  color: ${BASIC_DARK_GRAY};
`;

const MenuQuantityButton = styled.div`
  position: absolute;
  bottom: -15px;
  right: 0;
`;
